<template>
  <div class='registrationCenter'>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <!-- 空状态 -->
    <div class="empty tc" v-if="empty">
      <img src="https://qingbo-oss.oss-cn-beijing.aliyuncs.com/64d860f8-7106-4c2a-83ba-469226feb8e2.png">
      <p class="color-black f20">你还没有添加课程</p>
      <div @click="toRegister" class="toClass">去选课</div>
    </div>

    <div class="w">
      <div class="mb20" v-for="(item, index) in circularArray" :key="index">
        <OrderList v-if="isShowOrderList" @deletes='deletes($event)' @checkbox='checkbox(index)' :item="item" :listObj='listObj' :teacherObj='teacherObj' type='registrationCenter' />
      </div>
      <div style="width: 100%;height: 200px"></div>
    </div>

    <!-- 底部操作框 -->
    <div class="foot-contener w fbox fbox-ac fbox-jb" v-if="!empty">
      <div class="check-box fsh">
        <Checkbox @on-change="checkboxAll" v-model="single"><span class="check-title">全选</span></Checkbox>
      </div>
      <div class="fbox fbox-ac" v-if="curriculum === 0">
        <div class="money-box fbox">
          <p>合计：</p>
          <span>0</span>
        </div>
        <div class="submit-btn desable-btn f18 tc">提交选课</div>
      </div>
      <div class="fbox fbox-ac" v-else>
        <div class="money-box fbox fbox-w">
          <p class="fsh">合计：</p>
          <span>{{curriculum}}个课程</span>
          <!-- <span class="ml20">共{{course}}节课</span> -->
          <span class="ml20">共{{course}}个课时</span>
        </div>
        <div class="submit-btn red-btn f18 tc" @click="subClass">提交选课</div>
      </div>
    </div>

    <!-- 弹出框 删除 -->
    <PopUp :modal='delModal' @cancel='cancel' @ok='ok' text='确定' msg='确定删除所选课程吗？' />
    <!-- 弹出 提交选课 -->
    <PopUp :modal='subModal' @cancel='cancel' @ok='lookClass' text='查看选课' msg='您的选课已提交申请审核，请耐心等待' />

  </div>
</template>

<script>
import OrderList from '@/components/orderList'
import PopUp from '@/components/popUp'

export default {
  name: 'registrationCenter',
  components: {
    OrderList,
    PopUp
  },
  data () {
    return {
      delModal: false,
      subModal: false,
      single: false,
      isShowOrderList: false, // 是否显示组件
      circularArray: [], // 循环的数组
      listObj: {}, // 全部的对象
      teacherObj: {}, // 老师obj
      courseNum: 0,
      classNum: 0,
      empty: false,
      deleteId: '',
      idArr: {},
      curriculum: 0,
      course: 0,
      spinShow: true
    }
  },
  mounted () {
    this.init()
  },
  watch: {
  },
  methods: {
    async totalPrice () {
      var curriculum = 0
      var course = 0
      // 总价等于数量乘以数量listObj
      for (let key in this.listObj) {
        if (this.listObj[key].active) {
          curriculum += 1
          if (this.listObj[key].type === '0') {
            // course += this.listObj[key].allCourse || 0
            course += this.listObj[key].allPreinstallNum || 0
          } else {
            // course += this.listObj[key].num || 0
            course += this.listObj[key].preinstallNum || 0
          }
        }
      }
      this.curriculum = curriculum
      this.course = course
    },
    async init () {
      await this.getRegistrationCenter()
      this.spinShow = false
      if (!this.$getFlash('submit') || this.$getFlash('submit') === 0) { return }
      this.$setFlash('submit', 0)
      this.subModal = true
    },
    async getRegistrationCenter () {
      // 获取课程
      let res = await this.$tkParse.getList('/classes/registrationCenter', {
        params: {
          where: {
            user: this.$store.state.user.objectId
          }
        }
      })
      if (!res.length || !res[0].course.length) {
        this.empty = true
        this.circularArray = []
        return
      }
      this.idArr = res[0]
      this.circularArray = res[0].course // 页面循环得数组
      // 处理数据，请求课程
      let courseIdArr = []
      let courseMajorIdArr = []
      res[0].course.forEach(item => {
        if (item.type === '0') {
          courseMajorIdArr.push(item.id)
        } else {
          courseIdArr.push(item.id)
        }
      })
      let courseArr = await this.$tkParse.post('/web/getAllCourses', courseIdArr) // 请求云代码
      courseArr = courseArr.data
      let courseMajorArr = await this.$tkParse.post('/web/getAllCourseMajor', courseMajorIdArr) // 请求云代码
      courseMajorArr = courseMajorArr.data
      let obj = {}
      courseArr.forEach(item => {
        item['active'] = false
        item['type'] = '1'
        obj[item.objectId] = item
      })
      courseMajorArr.forEach(item => {
        item['active'] = false
        item['type'] = '0'
        obj[item.objectId] = item
      })
      // 获取老师
      let teacherId = []
      for (let key in obj) {
        if (obj[key].teacher) {
          teacherId = teacherId.concat(obj[key].teacher) // 合并数组
        }
      }
      teacherId = [...new Set(teacherId)]
      let teacherArr = await this.$tkParse.post('/web/getAllTeacher', teacherId) // 请求云代码
      this.teacherObj = teacherArr.data
      this.listObj = obj
      this.isShowOrderList = true
    },
    cancel () {
      this.deleteId = ''
      this.delModal = false
      this.subModal = false
    },
    async ok () {
      if (!this.deleteId) {
        this.$Message.warning('请重新选择')
        return
      }
      let newArr = []
      this.idArr.course.forEach((item, index) => {
        if (this.deleteId !== item.id) {
          newArr.push(item)
        }
      })
      let put = await this.$tkParse.put(`/classes/registrationCenter/${this.idArr.objectId}`, {
        course: newArr
      })
      if (put) {
        this.$Message.success('删除成功')
        this.init()
        this.single = false
        this.$store.commit('setCarNum', this.$store.state.carNum + 1)
        this.curriculum = 0
        this.course = 0
      } else {
        this.$Message.error('删除失败')
      }
      this.delModal = false
    },
    lookClass () {
      this.deleteId = ''
      this.subModal = false
      this.$push({
        path: '/accountCenter',
        query: {
          type: 'class'
        }
      })
    },
    async subClass () {
      let setData = []
      // let deleatId = [] // 需要删除的id
      for (let key in this.listObj) {
        if (this.listObj[key].active) {
          let obj = {
            type: this.listObj[key].type,
            id: this.listObj[key].objectId
          }
          // deleatId.push(this.listObj[key].objectId)
          setData.push(obj)
        }
      }
      // let newArr = []
      // this.idArr.course.forEach((item, index) => {
      //   if (deleatId.indexOf(item.id) !== -1) {
      //   } else {
      //     newArr.push(item)
      //   }
      // })
      // await this.$tkParse.put(`/classes/registrationCenter/${this.idArr.objectId}`, {
      //   course: newArr
      // })
      sessionStorage.setItem('order', JSON.stringify(setData))
      this.$push('/ordersSubmit')
      // this.subModal = true
    },
    async checkbox (clickIndex) {
      await this.totalPrice()
    },
    async checkboxAll () {
      for (let key in this.listObj) {
        this.listObj[key].active = this.single
      }
      await this.totalPrice()
    },
    deletes (id) {
      this.deleteId = id
      this.delModal = true
    },
    toRegister () {
      this.$push('/professional')
      sessionStorage.setItem('active', 1)
    }
  }
}
</script>
<style lang="scss" scoped>
.registrationCenter{
  background-color: #F5F5F8;
  padding: 20px 0 70px;
  position: relative;
  min-height: 90vh;
}
.foot-contener{
  // height: 90px;
  background: #FFFFFF;
  padding: 20px 40px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  .money-box{
    align-items: flex-end;
    margin-right: 60px;
    p{
      font-size: 20px;
      line-height: 20px;
      color: #8E9299;
    }
    span{
      font-size: 24px;
      line-height: 20px;
      color: #EA3553;
      font-weight: bold;
    }
  }
  .submit-btn{
    width: 160px;
    height: 60px;
    line-height: 60px;
    border-radius: 0;
  }
}
.check-box{
  ::v-deep{
    .ivu-checkbox-inner{
      width: 26px;
      height: 26px;
    }
    .ivu-checkbox-inner:after, .ivu-checkbox-inner:after{
      width: 8px;
      height: 16px;
      top: 2px;
      left: 8px;
    }
    .check-title{
      font-size: 16px;
      color: #8E9299;
      margin-left: 19px;
    }
  }
}
// 空状态
.empty{
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  img{
    width: 264px;
    height: 182px;
  }
  .toClass{
    width: 180px;
    height: 50px;
    line-height: 50px;
    background: #28B28B;
    border-radius: 4px;
    margin: 0 auto;
    color: #FFFFFF;
    font-size: 20px;
    margin-top: 30px;
    cursor: pointer;
  }
}
.red-btn{
  width: 80px;
  height: 30px;
  background-color: #ea3553;
  border-radius: 2px;
  color: #FFFFFF;
  cursor: pointer;
}
@media(max-width: 992px) {
  .foot-contener{
    padding: 10px 10px !important;
  }
  .submit-btn{
    width: 100px !important;
    height: 40px !important;
    line-height: 40px !important;
    font-size: 16px !important;
  }
  .money-box{
    p{
      font-size: 14px !important;
    }
    span{
      font-size: 14px !important;
    }
  }
  .check-box{
    // width: 30px;
    // text-align: center;
    ::v-deep{
      .ivu-checkbox-inner{
        width: 16px !important;
        height: 16px !important;
      }
      .ivu-checkbox-inner:after, .ivu-checkbox-inner:after{
        width: 4px !important;
        height: 8px !important;
        top: 2px !important;
        left: 5px !important;
      }
    }
  }
  .check-title{
    margin-left: 0px !important;
    font-size: 14px !important;
  }
  .money-box{
    margin-right: 10px !important;
  }
  .registrationCenter{
    ::v-deep{
      .biaoti{
        // height: 25px;
      }
    }
  }
  .money-box{
    span{
      margin-left: 0 !important;
    }
  }
}
</style>
